module.exports = __webpack_public_path__ + "static/media/picture-(125).04bf17e6.JPG";